import { Component, Input, ViewChild, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { CommonService } from 'fccore2';
import { NzTreeNode, NzFormatEmitEvent } from 'ng-zorro-antd';  

@Component({
    selector: 'fc-treeselect',
    template: `<nz-tree-select 
    style="width: 250px"
    [(ngModel)]="_innerValue" 
    [nzNodes]="fcNodes" 
    ngShowSearch  
    nzPlaceHolder="è¯·éæ©..."  
    (ngModelChange)="event('onChange',$event)"
    [nzCheckable]="fcOption.fcCheckable" 
    [nzMultiple]="fcOption.fcMutliple" 
    [nzDropdownMatchSelectWidth]="true" 
    [nzDropdownStyle]="{ 'max-height': '300px' }" 
    [nzAsyncData]="fcOption.fcAsync" 
    (nzExpandChange)="getChildren('expand',$event)" 
    [nzDefaultExpandedKeys]="fcExpandKeys"   
    [nzDefaultExpandAll]="fcOption.fcOpenChild" 
    (nzClick)="event('click',$event)" 
    [nzSize]="fcSize">
  </nz-tree-select>
    `,
    styles: [`
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FctreeselectComponent),
        multi: true
    }]
})
export class FctreeselectComponent extends FcinputComponent {
    _innervalue:any;
    @ViewChild('treeselect', {static: false})
    fcTree;
    @Input()
     /**éä¸­çèç¹åå®¹IDå¼*/
    fcId: string;
    @Input()
    fcNodes: any[];
     /**éç½®*/
    @Input()
    fcOption: TreeselectOptions;
    @Input()
    fcExpandKeys:string[];
     /**  å¼æ­¥åæ°*/
    _options = {
        allowDrag: false,
        getChildren: (node: any) => {
            let data = node.DATA;
            if (data === undefined) {
                data = node.data.DATA;
            }
            let obsv = this.appService.findWithQuery(this.fcAppid, {
                 /** WHERE: this.commonService.getStringFilterByParam(data, t*/
                ORDER: this.fcOption.fcOrderby
            });
            return new Promise((resolve, reject) => {
                this.pushDestroy(obsv.subscribe((result) => resolve(this._listtotreeasync(result.DATA, this.fcOption.fcChildCode,
                    this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode))));
            });
        }
    }
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-treeselect');
    }
    ngOnChanges(param): void { 
        this.fcSize ="small";
        this.fcNodes = undefined;
        if (this.fcOption === undefined) {
            new Error('ç¼ºå°fcOptionå±æ§');
        } 
        if (this.fcNodes === undefined) {
            this.fcNodes = [];
            this.fcAppid = this.fcOption.fcAppid;
            this.pushDestroy(this.appService.findWithQuery(this.fcAppid, {
                ORDER: this.fcOption.fcOrderby || '',
                WHERE: this.fcOption.fcTopWhere
            }).subscribe(result => {
                if (result.CODE === '0' && result.DATA.length !== 0) {
                    this.fcNodes = this._listtotreeasync(result.DATA,
                        this.fcOption.fcChildCode, this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode);
                }
            }));
        }
    }
     

    /**
     * å¨å­èç¹ä¸­è·åä¸çº§èç¹
     * @param node å½åå­èç¹
     */
    getChildren(evnet,node: NzFormatEmitEvent) {
        let data = node.node.origin.DATA; 
        if (this.fcAppid.length !== 0) {
            this.appService.findWithQuery(this.fcAppid, {
                WHERE: CommonService.getJsonStrFilterByParam(data, this.fcOption.fcExpWhere,"#"),
                ORDER: this.fcOption.fcOrderby
            }).subscribe(result => {
                if (result.CODE === '0') {
                    if (node.node) {
                        node.node.addChildren(this._listtotreeasync(result.DATA, this.fcOption.fcChildCode,
                            this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode));
                    } else {
                        node.node.addChildren(this._listtotreeasync(result.DATA, this.fcOption.fcChildCode,
                            this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode));
                    }
                }
            })
        }
    }
   
    /**
     * 
     * @description æ°ç»è½¬æ ç»æ
     * @param id idå¼
     * @param list æ°æ®åè¡¨
     * @param parentValue ä¸çº§ç¼ç çå¼
     * @param code ç¼ç 
     * @param name åç§°
     * @param subtitle å°æ é¢
     * @param parent ç¶çº§ç¼ç å­æ®µ
     * @param childFieldCode æ¯å¦æå­èç¹çåç§°
     * @param lastValue æ¯å¦ä½ä¸ºå¤æ­æ¯å¦æ¯å¶å­èç¹
     */
    private _listtotreeasync(list: any[], code: string, name: string, parent: string, childFieldCode: string): any[] {
        let nodes: any[] = [];
        list.forEach(item => {
            let node:any = {
                title: CommonService.getJsonStrFilterByParam(item, name,"#"),
                key: item[code],
                DATA: item
            };
            if (this.fcOption.fcLeafValue === undefined) { /**å¶å­èç¹çå¼æ¯éè¿æ­¤å¼è¿è¡å¤æ­æ¯å¦æ¯å¶å­æèæ¯å¦æ¯æ«çº§*/
                this.fcOption.fcLeafValue = 'Y';
            }
            if(item[this.fcOption.fcLeafCode]!==this.fcOption.fcLeafValue){
                node.isLeaf = true;
            }
             /** æ ¡éªæ¯å¦éä¸­*/
            if(this.fcOption.fcCheckable&&this._innerValue&&this._innerValue instanceof Array){
                let checkkeys = this._innerValue.filter(key=>key===item[code]);
                if(checkkeys.length>0){
                    node.checked=true;
                }
            }
            nodes.push(new NzTreeNode(node));
        })
        return nodes;
    }
}


export interface TreeselectOptions {
     /**åæ°æ®id*/
    fcAppid: string, /**åæ°æ®id*/
     /**æ ç»æèç¹æ¾ç¤ºåå®¹*/
    fcLabel: string, /**æ¯æ#{åæ°åç§°}# #{NAME}#:#{CODE}#*/
     /** å³èç¶èç¹å­æ®µåç§°*/
    fcParentCode: string, /**'PARENT',*/
     /** å½åèç¹å­æ®µåç§°*/
    fcChildCode: string, /**'CODE',*/
     /** å¶å­èç¹å­æ®µåç§°*/
    fcLeafCode: string, /**'ISLAST',*/
     /** æ ¹èç¹æ¡ä»¶*/
    fcTopWhere: string, /**"{or:[{parent:{IS:''}},{parent:{eq:''}}]}",*/
     /** å±å¼æ¡ä»¶*/
    fcExpWhere: string, /**"{PARENT:{eq:'#{MENUID}#'}}",*/
     /** æåºå­æ®µ*/
    fcOrderby: string,
     /** å±å¼å­èç¹*/
    fcOpenChild: boolean;
     /** å±å¼å­èç¹*/
    fcCheckable?: boolean;
     /** æ¯å¦å¤é*/
    fcMutliple?: boolean;
     /**æ¯å¦æ¾ç¤ºçº¿*/
    fcShowLine: boolean, 
     /**å¶å­èç¹çå¼æ¯éè¿æ­¤å¼è¿è¡å¤æ­æ¯å¦æ¯å¶å­æèæ¯å¦æ¯æ«çº§*/
    fcLeafValue?: string,
     /** é»è®¤å¼æ­¥å è½½ä¸ºfalse*/
    fcAsync?:boolean
};